














































































import {Vue, Component, Inject, Watch} from "vue-property-decorator";
import AtErrorHandler from "../ErrorHandler.vue";
import Api from "./Api";
import {CardUserdata} from "../../modules/models";
import SignoutIcon from "../SignoutIcon.vue";
import SideNav from "../sidenav/SideNav.vue";
import BaseApi from "../../store/modules/base";
import rd from "../../modules/vRoutedefs";
import {redirect} from "@/modules/utils";
import {NativeApi, OS} from "@/modules/NativeBridge";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";
import {AbortableDelay} from "@/modules/delay";


    class DrawerVal {
        initV: boolean = false;
        viewV: boolean = false;
        usrV: boolean | null = null;
        overrideV: boolean | null = null;

        get v() {
            if(this.overrideV !== null) {
                return this.overrideV;
            } else if(this.usrV !== null) {
                return this.usrV;
            }
            return this.initV && this.viewV;
        }
    }

    @Component({
        name: "at-scaffold",
        components: {
            "at-error-handler": AtErrorHandler,
            "at-signout-icon": SignoutIcon,
            "at-sidenav": SideNav,
            "at-ellips": Ellipsifier,
        }
    })
    export default class Scaffold extends Vue {
        @Inject()
        api!: Api;
        @Inject()
        baseApi!: BaseApi;
        @Inject()
        nativeApi!: NativeApi;

        drawerV = new DrawerVal();

        get drawer(): boolean {
            return this.drawerV.v;
        }
        set drawer(v: boolean) {
            this.drawerV.usrV = v;
        }

        get user(): CardUserdata | null {
            return this.baseApi.user;
        }

        isAboveBreakpoint() {
            const mobileBreakPoint = 1264; // Default value according to https://vuetifyjs.com/en/components/navigation-drawers
            return window.matchMedia(`(min-width: ${mobileBreakPoint}px)`).matches;
        }

        @Watch("$route", {immediate: true})
        onRouteChange() {
            this.drawerV.initV = this.$route.meta.initDrawer || false;
        }

        // Hides the drawer when printing page
        isPrintMode = false;

        get unreadMsgsCount() {
          return this.baseApi.unreadUsermessagesCount;
        }

        get company() {
            return this.baseApi.company;
        }

        get startPageTo() {
            return {name: rd.start.name};
        }
        get userSelfDisplayTo() {
            return {name: rd.start.me.name};
        }
        get loginConfigTo() {
            return {name: rd.login.config.name};
        }

        get wideToolbar() {
            return this.$vuetify.breakpoint.smAndUp
        }

        get showOptionsMenu() {
            return this.nativeApi.available && this.nativeApi.os === OS.Android;
        }

        get touchlessDrawer() {
            return !this.showOptionsMenu;
        }

        get usrMsgsTo() {
          return {name: rd.usermessages.name};
        }

        // Sets up listener that closes the drawer when navigation is performed and drawer is in "overlay" mode.
        initNavDrawerListener() {
            window.addEventListener("hashchange", () => {
                if(!this.isAboveBreakpoint()) {
                    this.drawerV.usrV = false;
                }
            })
        }

        @Watch("isPrintMode")
        onIsPrintModeChanged() {
            if(this.isPrintMode) {
                this.drawerV.overrideV = false;
            } else {
                this.drawerV.overrideV = null;
            }
        }

        async logout() {
            await this.api.logout(this.nativeApi);
            redirect(rd.public.path);
        }

        pageRefresh() {
            window.location.reload();
        }

        get hasPendingNotification() {
          return this.baseApi.unreadUsermessagesCount > 0;
        }

        private abortableDelay = new AbortableDelay();

        async periodicUnreadNotificationsCheck() {
          // Schedule a (re)run in three minutes
          this.abortableDelay.delay(3*60000, false).then((waited) => waited ? this.periodicUnreadNotificationsCheck() : null);
          try {
            if (this.baseApi.authenticated) { // don't call loadUnreadUsermessagesCount when not logged in, will fail and cause login prompt.
              await this.baseApi.loadUnreadUsermessagesCount();
            }
          } catch (e) {
            // Since this is run periodically in the background we don't want intermittent failures to cause error dialog displayed. Will just silently log errors to console instead
            console.warn(`Error fetching unread user messages count`, e);
          }
        }

        created() {
            if(window.matchMedia) {
                const printQL = window.matchMedia(`print`);
                // Setup listener for change
                if(printQL.addEventListener) {
                    printQL.addEventListener("change", (mql) => {
                        this.isPrintMode = mql.matches;
                    });
                }
                this.isPrintMode = printQL.matches; // Set initial value
            }

            this.drawerV.viewV = this.isAboveBreakpoint();
            this.initNavDrawerListener();
            this.periodicUnreadNotificationsCheck();
        }

        beforeDestroy() {
          this.abortableDelay.abort();
        }
    }
